import useIsInappWebview from "hooks/useIsInappWebview";
import { sendMessage } from "utils/webview";
import { BUILD_TARGET } from "config";
import useGetEventFromApp from "./useGetEventFromApp";
import { useEffect, useState } from "react";
import useLogin from "./useLogin";

// 카카오 로그인 scope 설정
const KAKAO_SCOPES = {
  real: "account_email,openid",
  dev: "account_email,openid",
} as const;

/**
 * 카카오 로그인 훅
 * - 인앱 웹뷰: 네이티브 앱으로 메시지 전송
 * - 일반 웹: 카카오 OAuth 페이지로 리다이렉트
 */
export default function useKakaoLogin() {
  const isInappWebview = useIsInappWebview();
  const [kakaoTokens, setKakaoTokens] = useState<
    { idToken: string; accessToken?: string; refreshToken?: string } | undefined
  >();

  const handleKakaoLoginApp = () => {
    sendMessage(JSON.stringify({ event: "kakao_login" }));
  };

  const parsedMessageFromApp = useGetEventFromApp();

  useEffect(() => {
    if (parsedMessageFromApp?.event === "kakao_idToken") {
      const idToken = parsedMessageFromApp.params.value;
      const accessToken = parsedMessageFromApp.params.accessToken;
      const refreshToken = parsedMessageFromApp.params.refreshToken;
      setKakaoTokens({
        idToken: idToken,
        accessToken: accessToken,
        refreshToken: refreshToken,
      });
    }
  }, [parsedMessageFromApp]);

  const login = useLogin({
    url: `/user/login`,
    idToken: kakaoTokens?.idToken!!,
    accessToken: kakaoTokens?.accessToken,
    refreshToken: kakaoTokens?.refreshToken,
    type: "kakao",
  });

  useEffect(() => {
    if (kakaoTokens) {
      login();
    }
  }, [kakaoTokens]);

  const handleKakaoLoginWeb = () => {
    if (!window.Kakao) {
      console.error("[Kakao Login] SDK가 로드되지 않았습니다.");
      return;
    }

    if (!window.Kakao.isInitialized()) {
      console.error("[Kakao Login] SDK가 초기화되지 않았습니다.");
      return;
    }

    const scope =
      BUILD_TARGET === "real" ? KAKAO_SCOPES.real : KAKAO_SCOPES.dev;

    window.Kakao.Auth.authorize({
      redirectUri: `${window.location.origin}/oauth/kakao`,
      scope,
    });
  };

  return isInappWebview ? handleKakaoLoginApp : handleKakaoLoginWeb;
}
